import GuestListActions from '../../actions/GuestListActions';

import UserStore from '../../stores/UserStore';

class Release extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            visible : false
        };

        this.releaseGuestFromPos = this.releaseGuestFromPos.bind(this);
    }

    releaseGuestFromPos(guest) {
        if (guest.RegisterId === '0')
            return;

        this.setState({ visible : false }, () => {
            var formData            = UserStore.getApiData();
            formData.Guest_id       = guest.Guest_id;
            formData.ShipmentId     = guest.ShipmentId;
            formData.RegisterId     = UserStore.getState().selectedRegister.id;
            formData.ScheduleId     = guest.ScheduleId;

            GuestListActions.releaseGuestFromPos(formData);
        });
    }

    render() {
        var self = this;
        var guest    = this.props.guest;

        var disabled = guest.RegisterId === '0' ? true : false;

        return (
            <li>
                <div
                    className={'btn-green '+(disabled ? 'btn-green__disabled' : '')}
                    onClick={() => { this.setState({ visible : (disabled ? false : true) }) }}>

                    RELEASE
                </div>

                { this.state.visible &&
                    <div className='popup popup__transparent'>
                        <div className='popup__content release'>

                            <div className='popup-header'>
                                CONFIRM

                                <div
                                    className='popup-close'
                                    onClick={() => { this.setState({ visible : false }) }}>

                                    <i className="fa fa-times" aria-hidden="true" />
                                </div>
                            </div>

                            <button
                                onClick={() => { this.setState({ visible : false }) }}>

                                CANCEL
                            </button>

                            <button
                                onClick={this.releaseGuestFromPos.bind(this, guest)}>

                                RELEASE
                            </button>
                        </div>
                    </div>
                }
            </li>
        );
    }
}

export default Release;



// WEBPACK FOOTER //
// ./ui_src/app/components/guest-list/Release.react.jsx